import { useContext } from 'react';

import { media } from 'context';
import { Button, Icon, Layout, Text } from 'ds';
import { Color, IconName } from 'shared';

interface MissingContentPlaceholderProps {
  icon: IconName;
  title: string;
  subtitle: string;
  buttonPath: string;
  backgroundColor?: Color;
  customButton?: React.ReactNode;
}
const MissingContentPlaceholder = ({
  icon,
  title,
  subtitle,
  buttonPath,
  backgroundColor = 'blue-50',
  customButton
}: MissingContentPlaceholderProps) => {
  const { isMobile } = useContext(media);
  return (
    <Layout
      width={isMobile ? '100%' : 724}
      color={backgroundColor}
      borderRadius={16}
      flex
      justify="center"
      align="center"
      paddingX={isMobile ? 24 : 181}
      paddingY={isMobile ? 48 : 48}
      gap={12}
    >
      <Layout direction="column" align="center" justify="center" gap={12}>
        <Icon name={icon} size="xxxl" color="blue-300" />
        <Layout flex direction="column" align="center" justify="center" gap={4}>
          <Text size="body-md" semibold align="center">
            {title}
          </Text>
          <Text size="body-sm" align="center">
            {subtitle}
          </Text>
        </Layout>
        {customButton ? customButton : <Button text="Shop" size="xs" type="purpleGradient" href={buttonPath} />}
      </Layout>
    </Layout>
  );
};

export default MissingContentPlaceholder;
